import { AddressesList, Title, Wrapper } from './AddressesWrapper.styled';
import { Fragment, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { AddressCreateForm } from '../Forms/Address';
import { AddressItem } from './AddressItem';
import type { UserAdressType } from '../../types/address';
import { retreiveUserAddresses, setPrimaryAddress } from '../../api/addresses';
import { setAddresses } from '../../store/addresses/addressesSlice';
import type { state } from '../../types/store/state';
import { useTranslation } from 'next-i18next';
import { WarningIcon } from '../Checkout/CheckoutWrapper/CheckoutWrapper.styled';
import { faExclamationCircle } from '@fortawesome/free-solid-svg-icons';

interface Props {
  condensed: boolean;
}

export const AddressesWrapper = ({ condensed }: Props) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const addresses = useSelector(({ addresses }: state) => addresses.results);

  const primaryAddress = useSelector(
    ({ addresses }: state) =>
      addresses.results.filter((address) => address.primary)
  );

  const [shouldEdit, setShoulEdit] = useState(false);
  const [addressToEdit, setAddressToEdit] = useState<UserAdressType>({
    id: 0,
    name: '',
    primary: false,
    address: {
      id: 0,
      address: '',
      description: '',
      city: '',
      state: '',
      zipcode: '',
      coordLat: '',
      coordLong: '',
    },
  });

  useEffect(() => {
    retreiveUserAddresses()
      .then(async (res) => {
        dispatch(setAddresses(res));

        const hasPrimary = res.results.some((address: any) => address.primary);

        if (!hasPrimary && res.results.length > 0) {
          const firstAddress = res.results[0];
          try {
            await setPrimaryAddress({ id: firstAddress.id });
            const updatedAddresses = await retreiveUserAddresses();
            dispatch(setAddresses(updatedAddresses));
          } catch (error) {
            console.error('Error setting first address as primary:', error);
          }
        }
      })
      .catch((error) => {
        throw new Error(error);
        });
  }, []);

  return (
    <Wrapper>
      <Title>
        {t('addresses.title')}
        {!primaryAddress.length && (
          <WarningIcon icon={faExclamationCircle} />
        )}
      </Title>
      <AddressesList>
        {addresses.map((userAddresses) => (
          <Fragment key={userAddresses.id}>
            <AddressItem
              {...userAddresses}
              setOpenEditAddressForm={setShoulEdit}
              openEditAddressForm={shouldEdit}
              setAddressToEdit={setAddressToEdit}
            />
          </Fragment>
        ))}
      </AddressesList>
      {shouldEdit ? (
        <AddressCreateForm
          shouldEdit={shouldEdit}
          addressToEdit={addressToEdit}
        />
      ) : null}
      <AddressCreateForm />
    </Wrapper>
  );
};
